import { useEffect, useState } from "react";
import { useAppDispatch } from "@hooks/useAppDispatch";
import { getClothes } from "@store/slices";
import { useAppSelector } from "@hooks/useAppSelector";
import { getClothesSelector } from "@store/selectors";
import { useTranslation } from "react-i18next";
import { Loader } from "@ui-kit/loader";
import { ProductCardCustom } from "@ui-kit/productCard2";
import styles from "./CategoryLayout.module.scss";

export const ClothesMight = () => {
  const { t } = useTranslation();
  const clothes = useAppSelector(getClothesSelector);
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    setLoading(true);
    dispatch(getClothes({ params: "?sort=desc&limit=4" })).then(() => {
      setLoading(false);
    });
  }, []);

  return (
    <div className={styles.cardBlcok2}>
      {clothes.length ? (
        clothes.map((item) => <ProductCardCustom data={item} key={item.id} />)
      ) : (
        <div className={styles.spin}>
          {loading ? (
            <Loader />
          ) : (
            <span className={styles.emptyDesc}>{t("category.not")}</span>
          )}
        </div>
      )}
    </div>
  );
};
